import { render, staticRenderFns } from "./AvailableInputMaterials.vue?vue&type=template&id=2f332906&scoped=true&"
import script from "./AvailableInputMaterials.vue?vue&type=script&lang=js&"
export * from "./AvailableInputMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f332906",
  null
  
)

export default component.exports